export default __webpack_public_path__ + "static/media/user-holly.d4c149b4.png";